(function () {
  'use strict';

  if (window.__gpDispatchInit) { return; }
  window.__gpDispatchInit = true;

  var roots = document.querySelectorAll('[data-gp-dispatch]');
  if (!roots.length) { return; }

  var ORDER = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var FULL = {
    Mon: 'Monday',
    Tue: 'Tuesday',
    Wed: 'Wednesday',
    Thu: 'Thursday',
    Fri: 'Friday',
    Sat: 'Saturday',
    Sun: 'Sunday'
  };

  function isWorkday(short) {
    return short !== 'Sat' && short !== 'Sun';
  }

  function nextWorkday(short) {
    var start = ORDER.indexOf(short);
    if (start < 0) { start = 0; }
    for (var i = 1; i <= 7; i += 1) {
      var candidate = ORDER[(start + i) % 7];
      if (isWorkday(candidate)) { return FULL[candidate]; }
    }
    return 'Monday';
  }

  function getDubaiClock(tz) {
    var formatter;
    try {
      formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h23'
      });
    } catch (e) {
      formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false
      });
    }

    var parts = formatter.formatToParts(new Date());
    var clock = { weekday: '', hour: 0, minute: 0 };

    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i];
      if (part.type === 'weekday') {
        clock.weekday = part.value;
      } else if (part.type === 'hour') {
        clock.hour = parseInt(part.value, 10) % 24;
      } else if (part.type === 'minute') {
        clock.minute = parseInt(part.value, 10);
      }
    }

    return clock;
  }

  function formatRemaining(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    var parts = [];

    if (hours > 0) { parts.push(hours + ' h'); }
    if (minutes > 0) { parts.push(minutes + ' min'); }

    return parts.join(' ');
  }

  Array.prototype.forEach.call(roots, function (root) {
    var text = root.querySelector('.gp-dispatch__text');
    if (!text) { return; }

    var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoffHour)) { cutoffHour = 14; }

    var cutoffMinute = parseInt(root.getAttribute('data-cutoff-minute'), 10);
    if (isNaN(cutoffMinute)) { cutoffMinute = 0; }

    var tz = root.getAttribute('data-tz') || 'Asia/Dubai';
    var cutoffMinutes = cutoffHour * 60 + cutoffMinute;

    function update() {
      var clock = getDubaiClock(tz);
      var nowMinutes = clock.hour * 60 + clock.minute;
      var message;

      if (isWorkday(clock.weekday) && nowMinutes < cutoffMinutes) {
        message = 'Order in the next ' + formatRemaining(cutoffMinutes - nowMinutes) + ' and we dispatch today from Dubai.';
      } else {
        message = 'Order now and we dispatch on ' + nextWorkday(clock.weekday) + ' from Dubai.';
      }

      text.textContent = message;
    }

    update();
    window.setInterval(update, 30000);
  });
})();
